export const spacingTokens = {
  'spacing-0': '0',
  'spacing-xs': '4px',
  'spacing-sm': '8px',
  'spacing-md': '12px',
  'spacing-lg': '16px',
  'spacing-xl': '24px',
  'spacing-2xl': '32px',
  'spacing-3xl': '48px',
  'spacing-4xl': '64px',
} as const;

export type SpacingTokens = typeof spacingTokens;
